<template>
  <v-row no-gutters align-content="center" :style="styles">
    <v-col :cols=12>
      <div class="text-h6 px-5">
        <slot/>
      </div>
    </v-col>
  </v-row>
</template>
<script>
export default {
  props: {
    borderLeftColor: {
      type: String,
      default: '#2D71BF'
    },
    backgroundColor: {
      type: String,
      default: '#E9F1F7'
    }
  },
  computed: {
    // バインドするスタイルを生成
    styles () {
      return {
        '--bdlcolor': this.borderLeftColor,
        '--bgcolor': this.backgroundColor
      }
    }
  }
}
</script>
<style scoped>
.text-h6 {
  border-left: 6px solid var(--bdlcolor) !important;
  background-color: var(--bgcolor) !important;
  color: #1F2B38 !important;
  font-size: 1.125rem !important;
  font-weight: bold !important;
  letter-spacing: 0px !important;
  margin-top: 4px !important;
  padding: .1em .5em !important;
}
.v-application .text-h6 .reccount {
  font-weight: 100;
  font-size: initial !important;
  display: inline-block;
  width:150px;
  margin-left:20px
}
</style>
